import { ViewportScroller } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet, Scroll } from '@angular/router';
import { filter } from 'rxjs';
import { AnalyticsComponent } from '../../../common/modules/analytics/analytics.component';
import { ServiceWorkerService } from '../../../common/services/service-worker.service';

@Component({
    selector: 'app-component',
    template: '<router-outlet/><app-analytics/>',
    imports: [
        RouterOutlet,

        AnalyticsComponent,
    ],
})
export class AppComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private serviceWorker = inject(ServiceWorkerService);
    private viewportScroller = inject(ViewportScroller);

    ngOnInit(): void {
        this.serviceWorker.init();

        this.router.events
            .pipe(
                filter((event): event is Scroll => {
                    let currentRoute: ActivatedRoute = this.route;
                    while (currentRoute.firstChild) {
                        currentRoute = currentRoute.firstChild;
                    }

                    if (currentRoute.snapshot.data.disableScrollRestoration) {
                        return;
                    }

                    return !currentRoute.snapshot.data.disableScrollRestoration && event instanceof Scroll;
                }),
            )
            .subscribe((event: Scroll) => {
                if (event.position) {
                    this.viewportScroller.scrollToPosition(event.position);
                } else if (event.anchor) {
                    this.viewportScroller.scrollToAnchor(event.anchor);
                } else {
                    this.viewportScroller.scrollToPosition([0, 0]);
                }
            });
    }
}
